import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { I18nProvider } from "@/i18n/I18nProvider";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import ProduitsPage from "@/pages/ProduitsPage";
import ProduitDetailPage from "@/pages/ProduitDetailPage";
import CommandesPage from "@/pages/CommandesPage";
import CommandeDetailPage from "@/pages/CommandeDetailPage";
import NouvelleCommandePage from "@/pages/NouvelleCommandePage";
import InventairePage from "@/pages/InventairePage";
import AchatsPage from "@/pages/AchatsPage";
import ExpeditionPage from "@/pages/ExpeditionPage";
import FacturationPage from "@/pages/FacturationPage";
import LivraisonsPage from "@/pages/LivraisonsPage";
import StatistiquesPage from "@/pages/StatistiquesPage";
import UtilisateursPage from "@/pages/UtilisateursPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PreviewPage from "@/pages/PreviewPage";
import { CURRENT_APP_ENVIRONMENT, isPreviewEnvironment } from "@/config/preview";

export default function App() {
  const preview = isPreviewEnvironment(CURRENT_APP_ENVIRONMENT);
  return (
    <ThemeProvider>
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route index element={preview ? <PreviewPage /> : <DashboardPage />} />
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/clients/:clientId" element={<ClientDetailPage />} />
              <Route path="/produits" element={<ProduitsPage />} />
              <Route path="/produits/:produitId" element={<ProduitDetailPage />} />
              <Route path="/commandes" element={<CommandesPage />} />
              <Route path="/commandes/nouvelle" element={<NouvelleCommandePage />} />
              <Route path="/commandes/:commandeId" element={<CommandeDetailPage />} />
              <Route path="/inventaire" element={<InventairePage />} />
              <Route path="/achats" element={<AchatsPage />} />
              <Route path="/expedition" element={<ExpeditionPage />} />
              <Route path="/facturation" element={<FacturationPage />} />
              <Route path="/livraisons" element={<LivraisonsPage />} />
              <Route path="/statistiques" element={<StatistiquesPage />} />
              <Route path="/utilisateurs" element={<UtilisateursPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  );
}
